export default "__VITE_ASSET__6e5c4acb__"